module.exports = "<p>\n  subpage-observacion-en-el-hogar works!\n</p>\n"